module.exports = __webpack_public_path__ + "eldrazi.jpg?1062a51b8ae2c3986776f59db083e4a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/eldrazi.jpg
// module id = 50
// module chunks = 0